
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 45 45"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-width":"1.4","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M9.782 13.657V37h6.783v-1.25c0-1.606 1.334-2.918 2.967-2.918 1.632 0 2.968 1.312 2.968 2.917V37h6.782v-1.25c0-1.606 1.335-2.918 2.968-2.918 1.631 0 2.967 1.312 2.967 2.917V37H42V13.657H9.782z"}}),_c('path',{attrs:{"d":"M35.218 10.335V7H3v23.343h3.391"}}),_c('path',{attrs:{"d":"M17.413 21.042c0-1.381 1.14-2.5 2.544-2.5 1.404 0 2.543 1.119 2.543 2.5s-1.139 2.501-2.543 2.501c-1.405 0-2.544-1.12-2.544-2.5z"}}),_c('path',{attrs:{"d":"M19.956 23.543c-3.633 0-5.087 3.023-5.087 5.167h10.174c0-2.144-1.453-5.167-5.087-5.167zm9.339 3.459h8.479m-8.479-3.341h8.479m-8.479-3.323h4.24"}})])])
          )
        }
      }
    